import api from '..'
import { CustomerPatient, CustomerPatientsResponse, UpdateCustomerPatient } from './types'
import { logger } from '../../utils/logger'

export const getCustomerPatientsFn = async (
  {
    page = '1',
    search
  }: { page: string, search?: string }
) => {
  try {
    const response = await api.get<CustomerPatientsResponse>(`auth/customer/patients?page=${page}${search ? `&search=${search}` : ''}`)
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Get patients error'), {
      type: 'get_patients_error',
      page,
      hasSearch: !!search
    })
    throw error
  }
}

export const createCustomerPatientFn = async (
  {
    name,
    description
  }: Omit<CustomerPatient, 'id'>
) => {
  try {
    const response = await api.post('auth/customer/patient', {
      name,
      description
    })

    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Create patient error'), {
      type: 'create_patient_error',
      patientName: name
    })
    throw error
  }
}

export const updateCustomerPatientFn = async (
  {
    name,
    description,
    id
  }: UpdateCustomerPatient
) => {
  try {
    const response = await api.patch('auth/customer/patient', {
      name,
      description,
      id
    })
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Update patient error'), {
      type: 'update_patient_error',
      patientId: id,
      patientName: name
    })
    throw error
  }
}
